<ng-container *ngIf="displayButton">
  <button
    mat-button vrm-bg-color
    class="cell-renderer-button"
    (click)="openDialog()"
  >{{ displayValue }}</button>
</ng-container>

<ng-container *ngIf="!displayButton">
  <span>{{ displayValue }}</span>
</ng-container>
